var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 6.418a7.373 7.373 0 0 1-2.121.581 3.702 3.702 0 0 0 1.624-2.043 7.398 7.398 0 0 1-2.346.896 3.693 3.693 0 0 0-6.293 3.368 10.485 10.485 0 0 1-7.612-3.858 3.683 3.683 0 0 0-.499 1.857c0 1.28.652 2.411 1.642 3.073a3.68 3.68 0 0 1-1.672-.462v.047a3.694 3.694 0 0 0 2.962 3.62 3.683 3.683 0 0 1-1.668.065 3.698 3.698 0 0 0 3.45 2.565A7.407 7.407 0 0 1 3 17.655a10.452 10.452 0 0 0 5.661 1.659c6.793 0 10.507-5.628 10.507-10.508 0-.16-.004-.32-.01-.478A7.519 7.519 0 0 0 21 6.418z",
    fill: "currentColor"
  })));
};
export default SvgTwitter;